"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ownItems = ownItems;

function ownItems(object) {
  var items = [];

  for (var property in object) {
    if (object.hasOwnProperty(property)) {
      // TODO yield object[property] instead?
      items.push([property, object[property]]);
    }
  }

  return items;
}